import { EventId, ProcessedEvent } from '../types'
import {
  addDays,
  addMinutes,
  endOfDay,
  isWithinInterval,
  startOfDay,
} from 'date-fns'
import { groupBy } from '@pogokid/util/lodash'
import { DURATION_MINS_DAY } from '@pogokid/util/datetime'

export function eventStartTimeComparator(
  a: ProcessedEvent,
  b: ProcessedEvent
): number {
  return a.start.getTime() - b.start.getTime()
}

export function findEventById(
  events: ProcessedEvent[],
  eventId: EventId
) {
  return events.find((e) => e.uid === eventId)
}

export function getSingleEventEnd(e: ProcessedEvent) {
  if (e.allDay) {
    return addDays(e.start, e.duration)
  } else {
    return addMinutes(e.start, e.duration)
  }
}

export function isMultiDayEvent(e: ProcessedEvent): boolean {
  return e.allDay
    ? e.duration > 1
    : e.duration > DURATION_MINS_DAY
}

/**
 * Checks whether the date is on a day covered
 * by the passed in event
 */
export function isDateWithinEventDayInterval(
  date: Date,
  event: ProcessedEvent
) {
  const end = getSingleEventEnd(event)
  return isWithinInterval(date, {
    start: startOfDay(event.start),
    end: endOfDay(end),
  })
}

/**
 * Checks whether one of the days in within
 * the start and end of the passed in event
 */
export function isEventOnDays(
  dates: Date[],
  event: ProcessedEvent
) {
  return dates.some((weekday) =>
    isDateWithinEventDayInterval(weekday, event)
  )
}

export function separateSingleAndMultiDayEvents(
  events: ProcessedEvent[]
): {
  singleDayEvents: ProcessedEvent[]
  multiDayEvents: ProcessedEvent[]
} {
  return {
    singleDayEvents: [],
    multiDayEvents: [],
    ...groupBy<ProcessedEvent>(
      (e) =>
        isMultiDayEvent(e)
          ? 'multiDayEvents'
          : 'singleDayEvents',
      events
    ),
  }
}
